import { createMockListResponse as e } from "../../../helpers/CreateMockListResponse.js";
//#region src/resources/batch-answer/runs/BatchAnswerEvaluationRuns.mocks.ts
var t = (e) => ({
	id: `run-${e}`,
	runNumber: e + 1,
	createdOn: "2021-01-01T00:00:00Z",
	createdBy: {
		userId: `user-${e}`,
		fullName: `User ${e}`
	},
	evaluationId: `evaluation-${e}`,
	notes: `Notes for run ${e}`,
	datasetSummary: {
		id: `dataset-${e}`,
		name: `Dataset ${e}`,
		totalQueries: 100 + e
	},
	queryPipelineSummary: {
		id: `pipeline-${e}`,
		name: `Pipeline ${e}`,
		crgaModels: [{
			name: "crgamodel",
			passageRelevanceSensitivity: e * .15,
			numberOfRankedResultsToConsider: e
		}]
	},
	facets: [],
	customContext: {},
	credentials: { type: "ANONYMOUS" },
	statistics: {
		startDate: "2021-01-01T00:00:00Z",
		answerRate: .5,
		isCompleted: !0
	}
}), n = (e) => ({
	queryId: `query-${e}`,
	query: `Sample query text ${e}`,
	state: "SUCCESS",
	answer: {
		id: `answer-${e}`,
		text: `Sample answer text ${e}`,
		contentFormat: "text/plain",
		citations: [{
			id: `citation-${e}`,
			title: `Sample citation title ${e}`,
			uri: `http://example.coveo.com/citation-${e}`,
			permanentId: `permanent-${e}`
		}]
	}
}), r = e(t), i = e(n);
//#endregion
export { t as createMockBatchAnswerRunItem, i as createMockBatchAnswerRunResultResponse, r as createMockBatchAnswerRunsListResponse };

//# sourceMappingURL=BatchAnswerEvaluationRuns.mocks.js.map